<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_xvi"><span class="bold">Acknowledgments</span></a></h2><a id="page_xvi">
<p class="noindent"><span class="dropcap">T</span>he author is grateful to the following people for permission to use their photographs:</p>
<p class="left1">Kiaran Allen</p>
<p class="lefta">Ron Rink</p>
<p class="lefta">Fiona Smith</p>
<p class="lefta">Skip Dolega</p>
<p class="lefta">Dave and Eileen Hughes</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_Acknowledgments.vue?2c5a0333